import { createPaths } from "@routes/utils";

import type { IExtractRouteParamMap } from "@routes";

const baseRoute = `/report-management/employee-activity-report`;

export const employeeActivityReportRoutesObj = {
  list: baseRoute,
  // TODO: ADD VIEW INVOICE AND DEBT PAYMENT PAGES LATER
} as const;

export type IEmployeeActivityReportRouteParams = IExtractRouteParamMap<
  typeof employeeActivityReportRoutesObj
>;

export const employeeActivityReportPath = createPaths<
  typeof employeeActivityReportRoutesObj,
  IEmployeeActivityReportRouteParams
>(employeeActivityReportRoutesObj);
